<section class="tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 tw-shadow-sm tw-rounded-xl tw-bg-white tw-min-h-0" id="manage-team">
  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-3 tw-justify-between tw-mb-3 tw-shrink-0">
    <div class="tw-flex tw-flex-col tw-gap-1 tw-items-start">
      <h2 class="tw-font-bold tw-text-gray-700 tw-text-lg tw-font-inter">Manage team</h2>
      <div class="tw-text-sm tw-text-gray-500 tw-text-start tw-font-inter tw-font-normal">
        Invite your team members to build and execute events together.
        <button
          type="button"
          class="tw-inline tw-text-blue-600 tw-font-medium tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-font-inherit tw-leading-inherit"
          (click)="openRolesPrivilegeTable()"
        >
          Roles Privilege table
        </button>
      </div>
    </div>
    <button
      class="tw-flex tw-gap-2 tw-font-inter tw-font-medium tw-text-sm tw-text-white tw-bg-blue-600 tw-border tw-border-blue-600 tw-rounded-md tw-px-3 tw-py-2 tw-items-center tw-w-fit tw-h-[37px] lg:tw-self-center tw-cursor-pointer"
      (click)="openInviteTeamMembersModal()"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_47961_67032)">
          <path
            d="M6.00195 0.499268V5.99927M6.00195 5.99927V11.4993M6.00195 5.99927H11.502M6.00195 5.99927H0.501953"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_47961_67032">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Invite
    </button>
  </div>
  <app-users-list
    class="tw-min-h-0"
    [users]="users()"
    [isLoading]="isLoadingUsers()"
    [isLoadingMore]="isLoadingMoreUsers()"
    [hasMore]="hasMoreUsers()"
    [isStatusActionsDisabled]="isUpdatingTeamMember()"
    (loadMore)="loadMoreUsers.emit()"
    (statusActionSelected)="onStatusActionSelected($event)"
    (updateTeamMemberRole)="onUpdateTeamMemberRole($event)"
  />
</section>

@if (isModalOpened(cancelInvitationModalId)) {
  <modal
    [id]="cancelInvitationModalId"
    [showFooterDivider]="false"
    [showHeaderDivider]="false"
    [widthClass]="'tw-w-auto lg:tw-w-[416px]'"
    [heightClass]="'tw-h-auto'"
    [closeButtonEnabled]="true"
    [enableBackdropClose]="true"
    (onCloseModal)="onCancelInvitationCancelled()"
  >
    <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-py-2" slot="body">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <g clip-path="url(#clip0_cancel_invitation_warning)">
          <path
            d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z"
            fill="#9CA3AF"
          />
        </g>
        <defs>
          <clipPath id="clip0_cancel_invitation_warning">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <p class="tw-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">
        Are you sure you want to cancel the invitation for <span class="tw-font-bold">{{ cancelInvitationDisplayName() }}</span>?
      </p>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pt-4 tw-pb-6" slot="footer">
      <button
        type="button"
        class="tw-flex tw-items-center tw-justify-center tw-text-white tw-bg-red-600 hover:tw-bg-red-700 focus:tw-ring-4 focus:tw-ring-red-300 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-px-3 tw-py-2 tw-font-inter"
        (mousedown)="$event.preventDefault()"
        (click)="onCancelInvitationConfirmed()"
      >
        Yes, I'm sure
      </button>
      <button
        type="button"
        class="tw-flex tw-items-center tw-justify-center tw-border tw-text-gray-800 tw-bg-white hover:tw-bg-gray-100 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-border-gray-200 tw-px-3 tw-py-2 tw-font-inter"
        (mousedown)="$event.preventDefault()"
        (click)="onCancelInvitationCancelled()"
      >
        No, cancel
      </button>
    </div>
  </modal>
} @if (showTeamMemberActionModal() && pendingTeamMemberAction(); as pendingAction) {
<app-team-member-action-modal
  [user]="pendingAction.user"
  [action]="pendingAction.action"
  (confirmed)="onTeamMemberActionConfirmed($event)"
  (closed)="onTeamMemberActionModalClosed()"
/>
} @if (showInviteTeamMembersModal()) {
<app-invite-team-members-modal
  [isInviting]="isInvitingTeamMember()"
  (closed)="onInviteTeamMembersModalClosed()"
  (invited)="onInviteTeamMember($event)"
  (openRolesPrivilegeTable)="openRolesPrivilegeTable()"
  (closeRolesPrivilegeTable)="onRolesTableClosed()"
/>
} @if (showTeamMemberRoleUpdateModal() && pendingTeamMemberRoleUpdate(); as pendingRoleUpdate) {
<app-team-member-role-update-modal
  [user]="pendingRoleUpdate.user"
  [role]="pendingRoleUpdate.role"
  (confirmed)="onTeamMemberRoleUpdateConfirmed($event)"
  (closed)="onTeamMemberRoleUpdateModalClosed()"
/>
} @if (showRolesTable()) {
<app-roles-table (closed)="onRolesTableClosed()" />
}
